import { Box, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, MenuDivider, Text } from "@chakra-ui/react";
import { ReactComponent as Bell } from '../../svg/bell.svg'
import { ReactComponent as HamburgerIcon } from '../../svg/Hamburger.svg'

import { ReactComponent as Dashboard } from '../../svg/tachometer-alt.svg'
import { ReactComponent as Courses } from '../../svg/book.svg'
import { ReactComponent as Announcements } from '../../svg/bullhorn.svg'
import { ReactComponent as Reports } from '../../svg/chart-line.svg'
import { ReactComponent as Settings } from '../../svg/cog.svg'
import { ReactComponent as Management } from '../../svg/management.svg'
import { ReactComponent as Schedule } from '../../svg/schedule.svg'
import { ReactComponent as LiveCourses } from "../../svg/live-sessions.svg";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { loadSettings, logout } from "../../redux/api_calls/apiCalls";
import { setAutocompleteVisibility } from "../../redux/actions/actions"
import { useEffect } from "react";

export default function Header() {
    const headerText = useSelector(state => state.headerState.headerText)
    const settingsData = useSelector(state => state.settingsState.settingsData)
    const dispatch = useDispatch()
    const history = useHistory()
    const user = JSON.parse(window.localStorage.getItem("user")) ? JSON.parse(window.localStorage.getItem("user")).user : null
     const logoutHandler = async () => {
        try {
            let response = await logout()
            if (response) {
                window.localStorage.removeItem("user")
                history.push('/login')
            }
        }
        catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
         if (user) {
             dispatch(loadSettings({ email: user.email }))
        }

        // eslint-disable-next-line
    }, [user])

    return (
        <Box
            d='flex'
            flexGrow='1'
            maxH='10vh'
            justifyContent={['space-between', 'space-between', 'space-between', 'flex-end']}
            alignItems='center' pt={['1.5rem', '1.5rem', '1rem']}
            p={['1.5rem', '1.5rem', '1.5rem', '2rem']}
            bgColor='transparent'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Box d={['flex', 'flex', 'flex', 'none']} justifyContent='center' alignItems='center'>
                <Menu>
                    <MenuButton
                        as={IconButton}
                        icon={<HamburgerIcon width='25px' />}
                        bg='transparent'
                        aria-label="Options"
                        _hover={{ bg: "#f8f8f8" }}
                        _active={{ bg: "#f8f8f8" }}
                        size={['xs', 'sm', 'md']}
                        p={['0.5rem', '0.5rem', '0.75rem']}
                        zIndex='5'
                        mr='1rem'
                        d={['flex', 'flex', 'flex', 'none']}
                    />
                    <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#93a2ba' zIndex='5' w='0' minW='fit-content'>
                        <MenuItem icon={<Dashboard width='16px' fill='#93a2ba' />}  onClick={() => history.push('/dashboard')}>Dashboard</MenuItem>
                        <MenuItem icon={<Courses width='16px' fill='#93a2ba' />} onClick={() => history.push('/courses')} >Library</MenuItem>
                        <MenuItem icon={<LiveCourses width='16px' fill='#93a2ba' />} onClick={() => history.push('/live-courses')} >Live Classes</MenuItem>
                        <MenuItem icon={<Announcements width='16px' fill='#93a2ba' onClick={() => history.push('/announcements')} />}>Announcements</MenuItem>
                        <MenuItem icon={<Management width='16px' fill='#93a2ba' />} onClick={() => history.push('/manage-classes')}>Manage Classes</MenuItem>
                        <MenuItem icon={<Schedule width='16px' fill='#93a2ba' onClick={() => history.push('/schedule')} />}>Schedule</MenuItem>
                        <MenuItem icon={<Reports width='16px' fill='#93a2ba' />} onClick={() => history.push('/reports')}>Analytics</MenuItem>
                        <MenuItem icon={<Settings width='16px' fill='#93a2ba' onClick={() => history.push('/settings')} />}>Settings</MenuItem>
                    </MenuList>
                </Menu>
                <Text fontSize={['20px', '25px', '30px', '40px']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>

            <Box justifyContent='flex-end' d='flex' width='40%' alignItems='center'>
                 
                <Menu>
                    <MenuButton
                        as={IconButton}
                        icon={<Image src={settingsData.avatar} fallbackSrc='/blank.png' alt='profile' borderRadius='50%' width={['30px', '35px', '40px', '50px']} height={['30px', '35px', '40px', '50px']} />}
                    />
                    <MenuList
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='600'
                        fontSize='15px'
                        color='#000000CC'
                        zIndex='5'
                        w='0'
                        minW='250px'
                        borderRadius='10px'
                        boxShadow='0px 10px 50px rgba(0, 0, 0, 0.2)'
                    >
                        <MenuItem fontSize='15px' fontWeight='600'>{settingsData.first_name} {settingsData.last_name}</MenuItem>
                        <Text pl='3' fontSize='13px' fontWeight='400' color='#00000099'>Mobile No: {settingsData.mobile_no}</Text>
                        <MenuDivider />
                        <MenuItem fontSize='15px' fontWeight='600' onClick={logoutHandler}>Logout</MenuItem>
                    </MenuList>
                </Menu>
            </Box>
        </Box>
    )
}
